import { bindActionCreators } from 'redux';
import {
    GET_COUNTRY_LIST_REQUEST,
    GET_COUNTRY_LIST_SUCCESS,
    GET_COUNTRY_LIST_FAILURE,
    GET_GLOBAL_FEATURES_REQUEST,
    GET_GLOBAL_FEATURES_SUCCESS,
    GET_GLOBAL_FEATURES_FAILURE,
    GET_COUNTRY_FEATURES_REQUEST,
    GET_COUNTRY_FEATURES_SUCCESS,
    GET_COUNTRY_FEATURES_FAILURE,
    SET_SELECTED_COUNTRY,
    SET_SELECTED_FEATURES,
    POST_GLOBAL_FEATURES_REQUEST,
    POST_GLOBAL_FEATURES_SUCCESS,
    POST_GLOBAL_FEATURES_FAILURE
} from '../constants/';

const INIT_STATE = {
    isLoading: false,
    isInitialFetch: true,
    data: [],
    error: null,
    selectedCountry: "",
    countryList:[],
    selectedFeatures:[]
}

export default (state = INIT_STATE, action) => {
    
    switch (action.type) {
        case GET_COUNTRY_LIST_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case GET_COUNTRY_LIST_SUCCESS:
            return {
                ...state,
                isLoading: false,
                countryList: action.payload.countryList,
                isInitialFetch: false,
            };
        case GET_COUNTRY_LIST_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload.error.stack,
            };

        case GET_GLOBAL_FEATURES_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case GET_GLOBAL_FEATURES_SUCCESS:
            return {
                ...state,
                isLoading: false,
                data: action.payload.globalFeatures,
                isInitialFetch: false,
            };
        case GET_GLOBAL_FEATURES_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload.error.stack,
            };

        case GET_COUNTRY_FEATURES_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case GET_COUNTRY_FEATURES_SUCCESS:
            return {
                ...state,
                isLoading: false,
                data: action.payload.globalFeatures,
                isInitialFetch: false,
            };
        case GET_COUNTRY_FEATURES_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload.error.stack,
            };
        case SET_SELECTED_COUNTRY:
            return {
                ...state,
                selectedCountry: action.payload.countryId,
                message:null,
                error:null
            };

        case SET_SELECTED_FEATURES:
            return {
                ...state,
                data: state.data.map((f) => {
                    if (f.id === action.payload.id) {
                        return {
                            ...f,
                            active: action.payload.isSelected
                        }
                    }
                    return f;
                }),
            };

            case POST_GLOBAL_FEATURES_REQUEST:
                return {
                    ...state,
                    isLoading: true,
                    error: null,
                };
            case POST_GLOBAL_FEATURES_SUCCESS:
                return {
                    ...state,
                    isLoading: false,
                    message: action.payload.message,
                    isInitialFetch: false,
                };
            case POST_GLOBAL_FEATURES_FAILURE:
                return {
                    ...state,
                    isLoading: false,
                    isInitialFetch: false,
                    error: action.payload.message || action.payload?.error?.message,
                };

        default:
            return state;
    }
};